import { routes as appRoutes } from '../app/'

export default [ ...appRoutes ]



// WEBPACK FOOTER //
// ./src/router/routes.js